import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TalentpoolService } from '../_services/talentpool.service';
import * as _ from 'underscore';
import { LoginService } from '../_services/login.service';
import { LocalStorageService } from '../_services/local-storage.service';

@Component({
    selector: 'app-share-talentpools-modal',
    templateUrl: './share-talentpools-modal.component.html',
    styleUrls: ['./share-talentpools-modal.component.scss'],
    standalone: false
})
export class ShareTalentpoolsModalComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal, private talentpoolService: TalentpoolService, private loginService: LoginService, private localstorageService: LocalStorageService) {
    this.getAllTeamMembers();
    this.currentUserId = this.localstorageService.getItem('userid');
  }

  @Input() bulkSharing: boolean = false;
  @Input() selectedTalentpools: any[] = null;
  currentUserId: any = null;
  allTeamMembers: any[] = [];
  selectedMembers: any[] = [];
  shareErrorMessage: string = '';

  ngOnInit() {
    
  }

  /**
   * Get existing share info for selected talentpools
   */
  getExistingShareInfoForTalentpools() {
    this.talentpoolService.getExistingShareInfoForTalentpools({ talentpools: this.selectedTalentpools.map(tp => tp.talentpoolid) }).subscribe((res: any) => {
      if(res && res.status === 'success') {
        const talentpoolShareInfo: any[] = res?.data?.shareInfo || [];

        this.allTeamMembers = this.allTeamMembers.map(mem => {
          const selected = this.selectedTalentpools.every(tp => {
            const currentTalentpoolId: number | string = tp.talentpoolid;
            return talentpoolShareInfo.some((mapping: any) => mapping.sharedwith === mem.userid && mapping.talentpoolid === currentTalentpoolId);
          });
          selected && this.selectedMembers.push(mem);
          return { ...mem, selected, shareMappingActive: !!selected };
        });
      }
    }, (err: any) => {
      console.log("[getExistingShareInfoForTalentpools error] SharedTalentpoolsListingComponent - ", err);
    })
  }

  getAllTeamMembers() {
    this.selectedMembers = [];
    this.loginService.getTagUsers('').subscribe((res: any) => {
      if(res && res.status === 'success') {
        const allMembers: any[] = res?.message || [];
        this.allTeamMembers = allMembers.filter(mem => mem.userid != this.currentUserId).map(mem => ({ ...mem, selected: false, shareMappingActive: false }));
        this.getExistingShareInfoForTalentpools();
      }
    })
  }

  isMemberSelected(userid: string | number) {
    return this.selectedMembers.includes(this.allTeamMembers.find(mem => mem.userid == userid));
  }

  /**
   * Change member selection
   * @param member 
   */
  changeMemberSelection(event, member) {
    this.shareErrorMessage = '';
    const checked = (event.target as HTMLInputElement).checked;
    member.selected = checked;
    if(checked) {
      this.selectedMembers.push(member);
    } else {
      this.selectedMembers = this.selectedMembers.filter(mem => mem.userid != member.userid);
    }
    this.selectedMembers = _.uniq(this.selectedMembers, 'userid');
  }

  shareTalentpools() {
    const granted = this.allTeamMembers.filter(mem => !mem.shareMappingActive && mem.selected).map(mem => mem.userid), revoked = this.allTeamMembers.filter(mem => mem.shareMappingActive && !mem.selected).map(mem => mem.userid);
    const disableShareButton = granted.length == 0 && revoked.length == 0;
    this.shareErrorMessage = disableShareButton ? 'Please select or deselect at least one member to share the talentpool with.' : '';
    if(disableShareButton) return;
    const payload = {
      talentpools: this.selectedTalentpools.map(tp => tp.talentpoolid),
      grant: granted,
      revoke: revoked
    }
    this.talentpoolService.shareTalentpools(payload).subscribe((res: any) => {
      if(res && res.status === 'success') {
        this.closeModal('success', `Access modified for ${this.selectedTalentpools.length} talentpool${this.selectedTalentpools.length > 1 ? 's' : ''} successfully`);
      } else {
        this.closeModal('error');
      }
    }, (err: any) => {
      this.closeModal('error', 'Something went wrong');
    });
  }

  /**
   * Close current modal with appropriate status
   * @param type 
   * @param message 
   */
  closeModal(type: string, message?: any) {
    if(type == 'error') {
      this.activeModal.dismiss(message);
    } else {
      this.activeModal.close(type == 'skip' ? 'user-dismissed' : message ? message : null);
    }
  }

}
